import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import {
  DashboardPage,
  DataDisputeReportPage,
  RequestsReportPage,
  VerificationRequestsReportPage,
} from 'src/pages/reports';
import { RouteProps } from 'src/types/router';

import { ReportsOutlet, ReportsRedirects } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <ReportsRedirects />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.reports.requests,
    element: <RequestsReportPage />,
    accessRoles: [BusinessRole.Employee],
  },
  {
    path: appRoutes.reports.dashboard,
    element: <DashboardPage />,
    accessRoles: [
      BusinessRole.EmployerAdmin,
      BusinessRole.PeoAdmin,
      BusinessRole.PeoSuperAdmin,
      BusinessRole.PeoPayrollProviderUser,
    ],
  },
  {
    path: appRoutes.reports.dataDisputes,
    element: <DataDisputeReportPage />,
    accessRoles: [
      BusinessRole.PeoPayrollProviderUser,
      ReactRouteAccessKey.hasPeoRoles,
      ReactRouteAccessKey.hasEmployerRoles,
      ReactRouteAccessKey.hasPlatformRoles,
    ],
  },
  {
    path: appRoutes.reports.verificationRequests,
    element: <VerificationRequestsReportPage />,
    accessRoles: [
      BusinessRole.PeoPayrollProviderUser,
      ReactRouteAccessKey.hasPeoRoles,
      ReactRouteAccessKey.hasEmployerRoles,
      ReactRouteAccessKey.hasPlatformRoles,
      ReactRouteAccessKey.hasVerifierRoles,
    ],
  },
];

export const REPORTS_ROUTE: RouteProps = {
  path: appRoutes.reports.index,
  element: <ReportsOutlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized, ReactRouteAccessKey.isNotPartnershipCompanyUser],
};
